<template>
  <transition>
    <div class="top_nav" v-show="visible">
      <a
        class="logo"
        href="/"
        bg-url="@/mobile_plan/assets/image/logo.png"
        v-bg
      ></a>

      <ul class="nav_list">
        <li><a href="https://www.flyme.com" target="_blank">Flyme</a></li>

      </ul>
    </div>
  </transition>
</template>

<script>
import { scrollHandle } from '../bus_key'
import { debounce, getScrollTop } from '@/utils'

export default {
  name: 'topNav',
  data() {
    return {
      visible: false,
    }
  },

  mounted() {
    let scrollTop = 0

    this.$event.on(
      scrollHandle,
      debounce((e) => {
        const curTop = getScrollTop()

        if (curTop + 1000 < scrollTop || curTop === 0) {
          this.visible = true
        } else {
          this.visible = false
        }

        scrollTop = curTop
      }, 200),
    )
  },
}
</script>

<style lang="less" scoped>
.top_nav {
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  max-width: 1000px;
  height: 0.92rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(0.6rem);
  padding-left: 0.48rem;
  box-sizing: border-box;
}

.logo {
  width: 1.73rem;
  height: 0.4rem;
  background-repeat: no-repeat;
  background-size: 100%;
}

.nav_list {
  display: flex;
  justify-content: space-between;
  height: 100%;
  margin: 0;
  padding: 0;
}

li {
  margin-right: 0.48rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

a {
  text-decoration: none;
  font-weight: 400;
  font-size: 0.18rem;
  line-height: 0.25rem;
  color: rgba(255, 255, 255, 0.8);

  &:hover {
    color: #fff;
  }
}

@media screen and (max-width: 374px) {
  .open_plate {
    display: none;
  }
}
</style>
